import {
  getSafeAreaTop,
  getSafeAreaBottom,
  typography,
  STANDARD_FOOTER_HEIGHT,
  STANDARD_TAB_HEIGHT,
  STANDARD_HEADER_HEIGHT,
  ICON_LARGE_SIZE,
  ICON_SMALL_SIZE,
  ICON_EXTRA_SMALL_SIZE,
} from '@planitgeo/treeplotter-ui-library';

export const ACCORDION_COLLAPSED_HEIGHT = 30;
export const ACCORDION_EXPANDED_HEIGHT = ACCORDION_COLLAPSED_HEIGHT + 115;

export const ACCORDION_EXPANDED_SCROLL_CALC = `calc(100dvh - ${STANDARD_HEADER_HEIGHT}px - ${STANDARD_TAB_HEIGHT}px - ${STANDARD_FOOTER_HEIGHT}px - ${ACCORDION_EXPANDED_HEIGHT}px - ${getSafeAreaTop()} - ${getSafeAreaBottom()})`;
export const ACCORDION_COLLAPSED_SCROLL_CALC = `calc(100dvh - ${STANDARD_HEADER_HEIGHT}px - ${STANDARD_TAB_HEIGHT}px - ${STANDARD_FOOTER_HEIGHT}px - ${ACCORDION_COLLAPSED_HEIGHT}px - ${getSafeAreaTop()} - ${getSafeAreaBottom()})`;

export const sharedStyles = {
  //SHARED SCROLL CALCULATION AND STYLING FOR SCROLLABLE CONTAINERS
  'scroll-container': {
    height: `calc(100dvh - ${STANDARD_FOOTER_HEIGHT}px - ${getSafeAreaBottom()})`,
    paddingBottom: `${STANDARD_FOOTER_HEIGHT}px`,
    '& .simplebar-content': {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: `${STANDARD_FOOTER_HEIGHT}px !important`,
    },
  },

  //SHARED NO PADDING RESPONSIVE CONTAINER
  'responsive-container-no-padding': {
    px: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
  },

  //SHARED ICON SIZING
  'icon-large': {
    fontSize: ICON_LARGE_SIZE,
  },
  'icon-small': {
    fontSize: ICON_SMALL_SIZE,
  },
  'icon-extra-small': {
    fontSize: ICON_EXTRA_SMALL_SIZE,
  },

  //SHARED TITLE STYLING FOR MAP TOOLS
  'map-tools-header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 2,
  },

  //SHARED SELECT INPUT LABEL OVERRIDE STYLING
  'input-label': {
    fontSize: typography.subtitle1.fontSize,
    backgroundColor: 'white',
    paddingRight: '6px',
    '&.Mui-focused': {
      color: 'rgba(0, 0, 0, 1)',
    },
  },

  //SHARED FORM LAYOUT STYLING
  'form-container': {
    position: 'fixed',
    marginTop: `calc(${STANDARD_HEADER_HEIGHT}px + ${getSafeAreaTop()})`,
    padding: 0,
  },
  'form-box': {
    m: 1,
    boxShadow: 3,
  },
  'form-action-container': {
    position: 'fixed',
    height: `${STANDARD_FOOTER_HEIGHT}px`,
    bottom: 0,
    left: 0,
    right: 0,
    p: 1,
    zIndex: 100,
  },
  'form-action-box': {
    display: 'flex',
    gap: 1,
  },
};
